module.exports = __webpack_public_path__ + "static/media/veneto-3-09.d1ee8315.jpg";